import { useEffect } from 'react';
import { useAnalytics } from '@/contexts/AnalyticsContext';

interface PerformanceMetrics {
  lcp?: number;
  fid?: number;
  cls?: number;
  fcp?: number;
  ttfb?: number;
}

export const PerformanceMonitor = () => {
  const { trackEvent } = useAnalytics();
  useEffect(() => {
    // Web Vitals monitoring
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.entryType === 'largest-contentful-paint') {
          const value = entry.startTime;
          console.log('LCP:', value);
          trackEvent('web_vital', { metric: 'LCP', value });
        }
        
        // First Input Delay
        if (entry.entryType === 'first-input') {
          const value = (entry as any).processingStart - entry.startTime;
          console.log('FID:', value);
          trackEvent('web_vital', { metric: 'FID', value });
        }
        
        // Cumulative Layout Shift
        if (entry.entryType === 'layout-shift' && !(entry as any).hadRecentInput) {
          const value = (entry as any).value;
          console.log('CLS:', value);
          trackEvent('web_vital', { metric: 'CLS', value });
        }
      });
    });

    // Observe performance metrics
    try {
      observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
    } catch (e) {
      // Fallback for browsers that don't support all entry types
      console.warn('Some performance metrics not supported');
    }

    // Monitor resource loading
    const resourceObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.duration > 1000) { // Log slow resources
          console.warn('Slow resource:', entry.name, 'Duration:', entry.duration);
          trackEvent('slow_resource', { name: entry.name, duration: entry.duration });
        }
      });
    });

    try {
      resourceObserver.observe({ entryTypes: ['resource'] });
    } catch (e) {
      console.warn('Resource monitoring not supported');
    }

    // Cleanup
    return () => {
      observer.disconnect();
      resourceObserver.disconnect();
    };
  }, []);

  // Preload critical resources
  useEffect(() => {
    const preloadCriticalResources = () => {
      // Preload hero images
      const heroImages = [
        '/lovable-uploads/69b1dd60-a9f8-468e-85c3-6dc3ddb382f5.png',
        '/lovable-uploads/1c3d17af-1c2a-429d-a68c-f6549a9d2aa5.png'
      ];

      heroImages.forEach(src => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = src;
        document.head.appendChild(link);
      });

      // Preload critical fonts
      const fontLink = document.createElement('link');
      fontLink.rel = 'preload';
      fontLink.as = 'font';
      fontLink.type = 'font/woff2';
      fontLink.crossOrigin = 'anonymous';
      fontLink.href = 'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hjQ.woff2';
      document.head.appendChild(fontLink);
    };

    preloadCriticalResources();
  }, []);

  return null; // This component doesn't render anything
};

export default PerformanceMonitor;